import { FilterListOutlined as FilterListOutlinedIcon } from "@mui/icons-material";
import { Button, MenuItem, MenuList, styled } from "@mui/joy";
import { ClickAwayListener } from "@mui/base/ClickAwayListener";
import { Popper } from "@mui/base/Popper";
import { useRef, useState } from "react";

export type SortField =
  | "dateAscending"
  | "dateDescending"
  | "invoiceNumberAscending"
  | "invoiceNumberDescending"
  | "recordNumberAscending"
  | "recordNumberDescending";

interface Props {
  setSortedField: (value: SortField) => void;
  sortedField: SortField;
}

const Popup = styled(Popper)({
  zIndex: 1000,
});

export default function InvoicesSort({ setSortedField, sortedField }: Props) {
  const sortButtonRef = useRef<HTMLButtonElement>(null);
  const [sortMenuOpen, setSortMenuOpen] = useState(false);

  const handleSortChange = (
    field: SortField,
  ) => {
    setSortedField(field);
    setSortMenuOpen(false);
  };

  return (
    <>
      <Button color="neutral" variant="plain" ref={sortButtonRef} onClick={() => setSortMenuOpen(!sortMenuOpen)}>
        <FilterListOutlinedIcon
          sx={{
            fontSize: "20px",
          }}
        />
      </Button>

      <Popup
        anchorEl={sortButtonRef.current}
        disablePortal
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 4],
            },
          },
        ]}
        open={sortMenuOpen}
      >
        <ClickAwayListener onClickAway={(event) => event.target !== sortButtonRef.current && setSortMenuOpen(false)}>
          <MenuList variant="outlined" sx={{ boxShadow: "md" }}>
            <MenuItem selected={sortedField == "dateAscending"} onClick={() => handleSortChange("dateAscending")}>
              Date (Ascending)
            </MenuItem>
            <MenuItem selected={sortedField == "dateDescending"} onClick={() => handleSortChange("dateDescending")}>
              Date (Descending)
            </MenuItem>
            <MenuItem
              selected={sortedField == "invoiceNumberAscending"}
              onClick={() => handleSortChange("invoiceNumberAscending")}
            >
              Invoice number (Ascending)
            </MenuItem>
            <MenuItem
              selected={sortedField == "invoiceNumberDescending"}
              onClick={() => handleSortChange("invoiceNumberDescending")}
            >
              Invoice number (Descending)
            </MenuItem>
            <MenuItem
              selected={sortedField == "recordNumberAscending"}
              onClick={() => handleSortChange("recordNumberAscending")}
            >
              Record number (Ascending)
            </MenuItem>
            <MenuItem
              selected={sortedField == "recordNumberDescending"}
              onClick={() => handleSortChange("recordNumberDescending")}
            >
              Record number (Descending)
            </MenuItem>
          </MenuList>
        </ClickAwayListener>
      </Popup>
    </>
  );
}
